import apiPaths from '../api-paths.js';

export default {
  checkDuplicate({ externalNumber, crmOriginal, crmNip, issueDate }) {
    return axios.post(
      `${ apiPaths.BOOKKEEPING }/evidences/check-duplicate`,
      { externalNumber, crmOriginal, crmNip, issueDate },
    );
  },
  index(query = '') {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences${ query }`);
  },
  indexNotSettled(query = '') {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/index-not-settled${ query }`);
  },
  async indexBankingOperationByEvidenceOriginal({ original, query = '' }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/${ original }/banking-operations${ query }`);
  },
  importFromFile({ fileId, evidenceEntryType, kpirEntryType, vatRegisterType, ledgerAccount } = {}) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/evidences/create-from-file`, {
      fileId,
      evidenceEntryType,
      kpirEntryType,
      vatRegisterType,
      ledgerAccount,
    });
  },
  downloadJpkEwpXml({ data }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/declarations/jpk-ewp/download/xml`, data);
  },
  downloadJpkPkpirXml({ data }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/declarations/jpk-pkpir/download/xml`, data);
  },

  showByOriginal({ original }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/by-original/${ original }`);
  },

  reindexByOriginal({ original }) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/evidences/reindex-by-original/${ original }`);
  },
};
